import { BaseBoxShapeTool } from 'tldraw'
export class DocShapeTool extends BaseBoxShapeTool {
	static  id = 'DocShape'
	static  initial = 'idle'
	shapeType = 'DocShape'
}